import { Component, Inject, Input, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { CompactType, DisplayGrid, GridType, GridsterConfig, GridsterItem } from 'angular-gridster2';
import { Dashboard, Dimension } from 'src/app/models/responses/dashboardResponse';
import { BussionFilterDefinition } from 'src/app/models/responses/dataStoreResponse';
import { WidgetFormComponent } from 'src/app/pages/manage/dashboard/dashboard-designer/widget-form/widget-form.component';
import { DashboardService } from 'src/app/services/dashboard/dashboard.service';
import { ModalService } from 'src/app/services/modal/modal.service';
import { ScriptLoaderService } from 'src/app/services/script-loader/script-loader.service';
import { SelfServiceDashboardFormComponent } from '../self-service-dashboard-form/self-service-dashboard-form.component';
import { ShareFormComponent } from '../modals/share-form/share-form.component';
import { DesignerContiner, GridsterWidget, Widget } from 'src/app/models/responses/widgetLibraryResponse';
import { deleteCssFile } from 'src/app/core/utils';
import { CoreService } from 'src/app/services/core/core.service';
import { ExpandedWidgetComponent } from '../modals/expanded-widget/expanded-widget.component';
import { GlobalFunctionService } from 'src/app/services/global-function/global-function.service';
import { DeviceDetectorService } from 'ngx-device-detector';
import { AvailableWidgetSelectionComponent } from '../available-widget-selection/available-widget-selection.component';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-self-service-designer',
  templateUrl: './self-service-designer.component.html',
  styleUrls: ['./self-service-designer.component.scss']
})
export class SelfServiceDesignerComponent implements OnInit, OnDestroy {
  @Input() data: {
    type: string,
    dashboard: Dashboard
  }


  dashboard: Dashboard = {
    dashboardId: "",
    title: "",
    icon: "",
    auditEnabled: 0,
    order: 1,
    dashboardStatus: 0,
    description: "",
    layoutConfig: "",
    domain: "",
    access: 0,
    owner: "",
    creationDate: "",
    updatedBy: "",
    updateDate: "",
    colorPalette: "",
    contentLanguage: '',
    filter: [],
    widgets: [],//Widget,
    dimensions: [], //Dimension,
    messages: [], //BussionMessage
    autoRefresh: 0,
    refreshInterval: 0,
    isMainDashboard: 0,
    hideBorders: "false",
    gridSize: 0,
    tags: "",
    css: "",
    ownerId: '',
    users: '',
    hideAdvancedQueryPanel: 0,
    layout: '',
    colors: []

  };
  widget: Widget = {
    visualComponentId: "",
    title: "",
    subTitle: "",
    footNote: "",
    access: 1,
    dateGroup: 0,
    customizeCode: 0,
    type: "",
    dataStoreId: "",
    owner: null,
    includeZeroValues: 1,
    domain: "",
    limitData: "500",
    code: "",
    sharedData: null,
    sort: {
      sortField: "",
      sortOrder: "",
      sortType: ""
    },
    colors: {
      type: 0,
      colors: [],
      onlyWidget: 0
    },
    dimensions: [],
    measures: [],
    filter: [],
    widgetParameters: [],
    dimensionsData: [],
    layout: {
      cols: 1,
      rows: 1,
      x: 0,
      y: 0,
      designerContainer: null
    },
    mobileLayout: {
      cols: 0,
      rows: 1,
      x: 0,
      y: 0,
      designerContainer: null
    },
    freezeFilter: 0,
    drillDownDashboard: '',
    drillDownLink: '',
    drillDown: {
      dashboard: '',
      dashboardFilter: 0,
      height: 0,
      width: 0,
      link: '',
      openerMethod: '',
      widgetFilter: 0,
      shareKey: ''

    },
    config: [],
    params: {},
    calculatedFields: [],
    isFilter: 0,
    offSet: -1,
    widgetQuery: '',
    ignoreFilterList: [],
    disableInMemoryCache: 0,
    widgetJoin: [],
    tags: []
  };

  firstForm: UntypedFormGroup;
  secondForm: UntypedFormGroup;
  thirdForm: UntypedFormGroup;
  loadingWidgets: boolean = false
  options: GridsterConfig;
  dashboardWidgets: Array<GridsterItem> = [];
  isShownFilter: boolean = false;
  dashboardId: string = "";
  pageForm: UntypedFormGroup;
  selectedDashboardId: string
  domain: string = null;
  visibletoggle: boolean = false

  routeList = [{ path: "/selfservice", name: this.translate.instant("SelfServicePage.SelfServiceHome") }, { path: "/selfservice/dashboard-list", name: this.translate.instant("HomePage.MyDashboards") }, { path: "/selfservice", name: this.translate.instant("SelfServicePage.DashboardDesigner") }]

  constructor(
    private router: Router,
    private dashboardService: DashboardService,
    private modalService: ModalService,
    private translate: TranslateService,
    private coreService: CoreService,
  ) { }

  ngOnInit(): void {



  }

  ngOnDestroy(): void {
    if (this.selectedDashboardId)
      deleteCssFile(this.selectedDashboardId)
  }




  openSaveDashboardModal(sendData: {
    widget: (GridsterItem & { designerContainer: DesignerContiner; })[],
    dashboard: Dashboard
  }) {
    let data = {
      ...sendData,
      widget:sendData.widget.map(item=>item.designerContainer.widget),
      type: 'create'
    }

    // {
    //   widget: this.widgets,
    //   type: this.selectedDashboardId ? 'update' : 'create',
    //   dashboard: this.dashboard
    // }

    this.modalService.openModal(data, SelfServiceDashboardFormComponent, 'auto', '50%').subscribe(result => {
      if (result) {
        if (!this.selectedDashboardId) {
          this.dashboard.dashboardId = result.object
          this.router.navigate(['selfservice/self-service-design', this.dashboard.dashboardId]);
        }
        this.saveDashboardLayout(sendData.widget);
      }
    });


  }



  saveDashboardLayout(widgets: (GridsterItem & {
    designerContainer: DesignerContiner;
  })[]) {
    // this.upsertWidget();
    this.dashboardService.updateDashboardLayout(this.dashboard.dashboardId, widgets, 0).subscribe(result => {
      if (result) {
        this.coreService.showSuccessMessage(result);
      }
    });
  }





}
